import { IsOwnTukNm, shippingDocColNm } from "branch/constant/shipping/shipping";
import { jobOrderColNm } from "constants/jobOrderConstant";
import { shipmentColNm } from "constants/shipmentConstant";

export const shippingInvoiceColNm = {
  ...shipmentColNm,
  CusAbbr: "รหัสลูกค้า",
  ManAccId: "ผู้รับผิดชอบงาน",
  IP_InvNo: "Invoice No.",
  IP_InvDte: "วันที่ Invoice",
  Bkg: "Booking",
  IP_Csgn: "Consignee",
  IP_ETD: "ETD",
  Note: "Note",
  IP_PO:"PO",
  IP_PoL: "Port of Loading",
  IP_PoD: "Port of Discharge",
  PLCreTm: "เวลารับ PL",
  OwnAccId: "ผู้ส่ง PL",
  OwnAccNm: "ผู้ส่ง PL",
  OwnAccEmail: "Email ผู้ส่ง PL",
  EDCreTm: "เวลาเพิ่ม Draf ใบขน",
  EDCreAccId: "ผู้สร้างใบขน",
  EDCreAccNNm: "ผู้สร้างใบขน",
  EDNo: "เลขที่ใบขน",
  EDAprvTm: "เวลาตรวจสอบใบขน",
  EDSndTm: "เวลาส่งใบขน",
  EDCfTm: "เวลายืนยันใบขน",
  ED0209CreTm: "เวลาสร้างใบขน",
  ED0209SndTm: "เวลาส่งสถานะ0209",
  ED0309CreTm: "เวลาเพิ่มสถานะ0309",
  ED0309SndTm: "เวลาส่งสถานะ0309",
  ED0409CreTm: "เวลาเพิ่มสถานะ0409",
  ED0409SndTm: "เวลาส่งสถานะ0409",
  CDCreTm: "เวลาสร้างใบกำกับตู้",
  CDCreAccId: "ผู้สร้างใบกำกับตู้",
  CDCreAccNNm: "ผู้สร้างใบกำกับตู้",
  CDAprvTm: "เวลาตรวจสอบใบกำกับตู้",
  CDSndTm: "เวลาส่งใบกำกับตู้",
  PayCstmTm: "เวลาจ่ายศุลกากร",
  Rmk: "หมายเหตุ",
  RtnPlc: jobOrderColNm.RtnPlc,
  ContNo: jobOrderColNm.ContNo,
  ISOCd: jobOrderColNm.ISOCd,
  SealNo: jobOrderColNm.SealNo,
  TareWt: jobOrderColNm.TareWt,
  GrossWt: "G.W.",
  TotalGW: "Total G.W.",
  CT: "จำนวนหีบห่อ/หน่วย(CT)",
  KGM: "น้ำหนักรวมหีบห่อ/หน่วย(KGM)",
  M3: "ปริมาตร(M3)",
  Vol: "จำนวนตู้",
  TotalKGM: "VGM WEIGHT",
  ShpTypId: "ประเภทยานภาหนะ",
  Cnee: "Consignee",
  BLRecvTm: "เวลา รับ B/L",
  BLCfTm: "เวลา Confirm HBL",
  BLSndTm: "เวลาส่ง HBL",
  ANRecvTm: "เวลารับ Notice",
  MBLRecvTm: "เวลารับ MBL",
  MBLEntrTm: "เวลา Enter MBL",
  FrtInvTm: "เวลา Inv สายเรือ",
  FrtInvPaidTm: "เวลาชำระเงินสายเรือ",
  DOMailTm: "เวลาส่งจ.ม.แลก D/O",
  DORecvTm: "เวลารับ D/O",
  CstmFormDfTm: "Draft ใบขน",
  CstmFormCfTm: "Confirm ใบขน",
  CstmClrTm: "วันที่ผ่านพิธีการศุลกากร",
  BLSts: "สถานะงาน",
  DemFreeTm: "Dem Free Time",
  DemStDte: "Dem Start Date",
  DetFreeTm: "Det Free Time",
  DetStDte: "Det Start Date",
  ContNos: "หมายเลขเลขตู้ใน B/L",
  ManAccNNm: "ผู้รับผิดชอบงาน",
  SealContTm: "เวลาปิดตู้",
  IsOwnTuk: IsOwnTukNm,
  ScId: "จ้าง Shipping",
  FormTm: "เอกสารต่างๆ",
  Doc1Tm: shippingDocColNm.Doc1Tm,
  Doc2Tm: shippingDocColNm.Doc2Tm,
  DocSndTm: "เวลาส่งเอกสารตัวจริง",
  Brnd: "ตราสินค้า",
  TakePlc: shipmentColNm.TakePlc
}